import { createVuetify, type ThemeDefinition } from 'vuetify'
import {
  VTextField,
  VAutocomplete,
  VSelect,
  VTextarea,
  VDatePicker,
  VExpansionPanels,
  VExpansionPanel,
  VExpansionPanelText,
  VExpansionPanelTitle,
  VBtn,
  VSlider,
  VDialog,
  VDivider,
  VForm,
  VCard,
  VListItem,
  VAvatar,
  VRow,
  VCol
} from 'vuetify/components'
import { es } from 'vuetify/locale'

import 'vuetify/styles'

const asisaTheme: ThemeDefinition = {
  dark: false
}

export default createVuetify({
  components: {
    VTextField,
    VAutocomplete,
    VSelect,
    VTextarea,
    VDatePicker,
    VExpansionPanels,
    VExpansionPanel,
    VExpansionPanelText,
    VExpansionPanelTitle,
    VBtn,
    VSlider,
    VDialog,
    VDivider,
    VForm,
    VCard,
    VListItem,
    VAvatar,
    VRow,
    VCol
  },
  theme: {
    defaultTheme: 'asisaTheme',
    themes: {
      asisaTheme
    }
  },
  icons: {
    defaultSet: 'mdi'
  },
  locale: {
    locale: 'es',
    messages: { es }
  }
})
